import Layout from "@/views/layout/index";

const data = [
  {
    path: "/government",
    name: "Government",
    target: true,
    hidden: true,
    component: Layout,
    isChildren: true,
    mCode:"ZCHQ",
    meta: {title: '政策惠企', icon: 'el-icon-s-help'},
    children: [
      {
        path: '/government',
        // hidden: true,
        meta: {title: '首页', icon: 'el-icon-s-help'},
        component: () => import('@/views/government/index'),
      },
      {
        path: '/government/policy',
        meta: {title: '政策直达', icon: 'el-icon-s-help'},
        component: () => import('@/views/government/policy'),
      },
      {
        path: '/government/mattersHandling',
        meta: {title: '事项办理', icon: 'el-icon-s-help'},
        component: () => import('@/views/government/mattersHandling'),
      },
      // {
      //   path: '/government/publicService',
      //   meta: {title: '公共服务', icon: 'el-icon-s-help'},
      //   component: () => import('@/views/government/publicService'),
      // },
      // {
      //   path: '',
      //   meta: {title: '优化营商', icon: 'el-icon-s-help'},
      //   component: () => import('@/views/government/index'),
      // },
      {
        path: 'https://standard.hbgyl.com.cn/homeThirdParty',
        open:true,
        target: true,
        hidden: true,
        meta: {title: '标准化服务', icon: 'el-icon-s-help'},
        component: () => import('@/views/government/index'),
      },
      {
        path: '/government/searchResult',
        target: true,
        hidden: true,
        meta: {title: '搜索结果', icon: 'el-icon-s-help'},
        component: () => import('@/views/government/searchResult'),
      },
      {
        path: '/gov/hy',
        name: '/gov/hy',
        target: true,
        hidden: true,
        meta: {title: '快捷申报入口', icon: 'el-icon-s-help'},
        component: () => import('@/views/government/fastPortResult'),
      }
    ]
  },
  {
    path: '/government/publicService',
    target: true,
    hidden: true,
    meta: {title: '公共服务', icon: 'el-icon-s-help'},
    component: () => import('@/views/government/publicService'),
  },
  {
    path: '/government/policyDetail',
    target: true,
    hidden: true,
    meta: {title: '政策详情', icon: 'el-icon-s-help'},
    component: () => import('@/views/government/policyDetail'),
  },
  {
    path: '/government/policyApply',
    target: true,
    hidden: true,
    meta: {title: '在线申报', icon: 'el-icon-s-help'},
    component: () => import('@/views/government/policyApply'),
  },
  {
    path: '/government/itemDetail',
    target: true,
    hidden: true,
    meta: {title: '项目详情', icon: 'el-icon-s-help'},
    component: () => import('@/views/government/itemDetail'),
  }
]

export default data



// WEBPACK FOOTER //
// ./src/router/government/index.js